import { createContext, useContext } from "react";
import type { GruppenReiter } from "./navigation";

/** Reiter je Gruppe der Navigation, gefiltert nach den Rechten der Person. Die Shell stellt sie bereit (BAUPLAN-PAKETE.md, Abschnitt 5.2). */
export const GruppenKontext = createContext<ReadonlyMap<string, GruppenReiter[]>>(new Map());

/** Erlaubte Seiten einer Gruppe, in der Reihenfolge der Navigation */
export function useGruppe(name: string): GruppenReiter[] {
  return useContext(GruppenKontext).get(name) ?? [];
}
